import React, { useState } from 'react';
import { Stack, Card, CardContent, CardMedia, Typography, Box } from '@mui/material';

const styles ={
    root: {
        width:200,
    },
    card: {
        maxWidth: 300,
        margin: 2,
    },
    media: {
        height: 140,
        backgroundSize: "contain"
    }, 
}

const SelectedImageDisplay = ({selectedImages}) => {
const handleDragStart = (img) => {
    return (e) => {
        e.dataTransfer.setData('text/plain', img);
    }
  };
    return (
        <Stack sx={styles.root} justifyContent="flex-start">
            {selectedImages.map((image, index) => (
                    <Card sx={styles.card}
                        draggable
                        onDragStart={handleDragStart(index)}
                    >
                        <CardMedia
                            sx={styles.media}
                            image={URL.createObjectURL(image)}
                            title={`Image ${index}`}
                        />
                        <Box sx={{marginBottom:1, paddingBottom:0, display:'flex', justifyContent:'center'}}>
                            <Typography variant="body2" color="textSecondary" component="p">
                                Image {index+1}
                            </Typography>
                    </Box>
                    </Card>

            ))}
        </Stack>
    );
}


export default SelectedImageDisplay;
